module.exports = __webpack_public_path__ + "static/media/home.bc5e575b.png";